import Home from "pages";
import { useEffect } from "react";
import { getPageData } from "../../utils/getSeoMenu";
import {
  viewFrontPage,
} from "@/components/common/Nosto";
import { useRouter } from "next/compat/router";
import { useDispatch, useSelector } from "react-redux";
import { setGlobalActiveTab } from "@/redux/actions/generalAction";
import { openWishlistSidebar } from "@/redux/actions/wishlistAction";
import { openAccountSidebar } from "@/redux/actions/loggedInUser";

export async function getServerSideProps() {
  return {
    props: {
      homepage: await getPageData('/') || null,
    },
  };
}

const ActivateAccountPage = ({ homepage }) => {
  const router = useRouter();
  const loggedIn = useSelector((state) => state.loginUser);
  const dispatch = useDispatch();

  //to handle api calls when logged in using /login
  useEffect(() => {
    if (router.asPath === "/account/orders") {
      dispatch(setGlobalActiveTab("orders"));
    }
    else if (router.asPath === "/account/impact") {
      dispatch(setGlobalActiveTab("my-impact"));
    }
    else if (router.asPath === "/account/wishlist") {
      if(loggedIn.userLoggedIn){
        dispatch(openWishlistSidebar(false))
        dispatch(setGlobalActiveTab("wishlist"));
      } else{
        dispatch(openWishlistSidebar(true))
        dispatch(setGlobalActiveTab(false))
        dispatch(openAccountSidebar(false))
      }
    }
    else {
      dispatch(setGlobalActiveTab(false));
    }
  }, [loggedIn.userLoggedIn])

  return (
    <>
      <Home accountOpen={true} tabToOpen={"home"} content={homepage} />
    </>
  );
};

export default ActivateAccountPage;
